<div>
  @if (propertiesCommand) {
  <h1 mat-dialog-title>
    {{ "command-modal.title" | translate }}
  </h1>
  }
  @if (propertiesCommand) {
  <hr />
  }
  @if (data) {
  <div mat-dialog-content>
    @if (propertiesCommand) {
    <p-table class="table-container" [value]="data" [paginator]="true" [rows]="10" [totalRecords]="resultsLength">
      <ng-template pTemplate="header">
        <tr>
          <th pSortableColumn="demo-name">{{ "command-modal.reference" | translate }}</th>
          <th pSortableColumn="demo-status">{{ "command-modal.status" | translate }}</th>
          <th pSortableColumn="response-date"> {{ "command-modal.generating-receiving-the-response" | translate }}:</th>
          <th pSortableColumn="view-status-commands">{{ "command-modal.button-view" | translate }}</th>
        </tr>
      </ng-template>
      <ng-template pTemplate="body" let-row let-columns="columns" let-ri="rowIndex">
        <tr>
          <td>{{row.reference}}</td>
          <td>
            @if (row.status === 'SUCCESS') {
            <p>
              {{ "command-modal.success" | translate }}
            </p>
            }
            @if (row.status === 'QUEUED') {
            <p>
              {{ "command-modal.queued" | translate }}
            </p>
            }
            @if (row.status === 'DEV_ERR') {
            <p>
              {{ "command-modal.error" | translate }}
            </p>
            }
            @if (row.status === 'INVALID') {
            <p>
              {{ "command-modal.invalid" | translate }}
            </p>
            }
          </td>
          <td>
            {{ row.responseGenerationDt }} {{row.responseReceiptDt }}
          </td>
          <td>
            <p-button styleClass="btn-actions" icon="pi pi-eye" class="mr-2" [rounded]="true" title="Visualizar comando"
              (click)="viewPropertiesCommand(row)" />
          </td>
        </tr>
      </ng-template>
    </p-table>
    }
    <!-- Modal de status das propriedades dos comandos -->
    @if (!propertiesCommand) {
    <div class="modal-properties-commands">
      <!-- Botão para voltar ao modal de equipamentos -->
      <p-button styleClass="btn-actions" icon="pi pi-chevron-left" [rounded]="true" title="Voltar para equipamentos"
        (click)="openEquipmentsModal()" />

      <!-- Ícone para fechar o modal -->
      <p-button class="close-properties-command" styleClass="btn-actions" icon="pi pi-times" [rounded]="true"
        title="Fechar modal" [mat-dialog-close]="data" />
      <!-- Título com o tipo de comando -->
      @if (equipmentSelected.commands.type) {
      <h1>
        {{ "command-modal.command-status-title" | translate }}
        @if (equipmentSelected.commands.type) {
        <h2>
          {{ equipmentSelected.commands.type }}
        </h2>
        }
      </h1>
      }
      <!-- Hora setada do agendamento, se houver -->
      @if (equipmentSelected.commands.type === 'Agendamento') {
      <h1>
        @if (equipmentSelected.command_switchOffTime) {
        <h2>
          <strong> {{ "command-modal.turn_off_scheduled" | translate }}: </strong>
          {{ equipmentSelected.command_switchOffTime }}
        </h2>
        }
        @if (equipmentSelected.command_switchOnTime) {
        <h2>
          <strong> {{ "command-modal.turn_on_scheduled" | translate }}: </strong>
          {{ equipmentSelected.command_switchOnTime }}
        </h2>
        }
      </h1>
      }
      <hr />
      <!-- Lista das propriedades dos comandos -->
      @if (equipmentSelected.responseData.relay != null) {
      <li>
        <strong> {{ "command-modal.relay" | translate }}: </strong>
        {{ equipmentSelected.responseData.relay }}
      </li>
      }
      @if (equipmentSelected.responseData.ir) {
      <li>
        <strong>{{ "command-modal.network-identification" | translate }}:
        </strong>
        {{ equipmentSelected.responseData.ir }}
      </li>
      }
      @if (equipmentSelected.responseData.tga != null) {
      <li>
        <strong>
          {{ "command-modal.timing-application-messages" | translate }}:
        </strong>
        {{ equipmentSelected.responseData.tga }}
      </li>
      }
      @if (equipmentSelected.responseData.tge != null) {
      <li>
        <strong>
          {{ "command-modal.timing-diagnostic-messages" | translate }}:
        </strong>
        {{ equipmentSelected.responseData.tge }}
      </li>
      }
      @if (equipmentSelected.responseData.tgm != null) {
      <li>
        <strong>
          {{ "command-modal.timing-after-relay-docking" | translate }}:
        </strong>
        {{ equipmentSelected.responseData.tgm }}
      </li>
      }
      <!-- Verificar tradução -->
      @if (equipmentSelected.responseData.tc != null) {
      <li>
        <strong> Tc: </strong> {{ equipmentSelected.responseData.tc }}
      </li>
      }
      @if (equipmentSelected.responseData.has_digital_measurement != null) {
      <li>
        <strong>
          {{ "command-modal.has-digital-measurement" | translate }}:
        </strong>
        {{ equipmentSelected.responseData.has_digital_measurement }}
      </li>
      }
      @if (equipmentSelected.responseData.has_ldr != null) {
      <li>
        <strong> {{ "command-modal.has-ldr" | translate }}:</strong>
        {{ equipmentSelected.responseData.has_ldr }}
      </li>
      }
      @if (equipmentSelected.responseData.ldr_priority != null) {
      <li>
        <strong>{{ "command-modal.ldr-priority" | translate }}:</strong>
        {{ equipmentSelected.responseData.ldr_priority }}
      </li>
      }
      @if (equipmentSelected.responseData.serial_number != null) {
      <li>
        <strong>{{ "command-modal.serial-number" | translate }}:</strong>
        {{ equipmentSelected.responseData.serial_number }}
      </li>
      }
      @if (equipmentSelected.responseData.major != null) {
      <li>
        <strong>{{ "command-modal.version" | translate }}:</strong>
        {{ equipmentSelected.responseData.major }}.{{
        equipmentSelected.responseData.minor
        }}.{{ equipmentSelected.responseData.rev }}
      </li>
      }
      @if (equipmentSelected.responseData.switch_on_time != null) {
      <li>
        <strong>{{ "command-modal.switch-on" | translate }}:</strong>
        {{ equipmentSelected.responseData.switch_on_time }}
      </li>
      }
      @if (equipmentSelected.responseData.switch_off_time != null) {
      <li>
        <strong>{{ "command-modal.switch-off" | translate }}:</strong>
        {{ equipmentSelected.responseData.switch_off_time }}
      </li>
      }
      @if (equipmentSelected.responseData.nacks_count != null) {
      <li>
        <strong>{{ "command-modal.nacks-count" | translate }}:</strong>
        {{ equipmentSelected.responseData.nacks_count }}
      </li>
      }
      @if (equipmentSelected.responseData.acks_count != null) {
      <li>
        <strong>{{ "command-modal.acks-count" | translate }}:</strong>
        {{ equipmentSelected.responseData.acks_count }}
      </li>
      }
      @if (equipmentSelected.responseData.reboots != null) {
      <li>
        <strong>{{ "command-modal.reboots" | translate }}:</strong>
        {{ equipmentSelected.responseData.reboots }}
      </li>
      }
      @if (equipmentSelected.responseData.command_fail_count != null) {
      <li>
        <strong>{{ "command-modal.command-fail-count" | translate }}:</strong>
        {{ equipmentSelected.responseData.command_fail_count }}
      </li>
      }
      @if (equipmentSelected.responseData.internal_temperature != null) {
      <li>
        <strong>{{ "command-modal.internal-temperature" | translate }}:</strong>
        {{ equipmentSelected.responseData.internal_temperature }}ºC
      </li>
      }
      @if (equipmentSelected.responseData.lux_switch_on_value != null) {
      <li>
        <strong> {{ "command-modal.lux-switch-on-value" | translate }}:</strong>
        {{ equipmentSelected.responseData.lux_switch_on_value }}
      </li>
      }
      @if (equipmentSelected.responseData.lux_switch_off_value != null) {
      <li>
        <strong>
          {{ "command-modal.lux-switch-off-value" | translate }}:
        </strong>
        {{ equipmentSelected.responseData.lux_switch_off_value }}
      </li>
      }
      @if (equipmentSelected.responseData.ldr_check_interval != null) {
      <li>
        <strong> {{ "command-modal.ldr-check-interval" | translate }}: </strong>
        {{ equipmentSelected.responseData.ldr_check_interval }}
      </li>
      }
      @if (equipmentSelected.responseData.lamp_status_detection != null) {
      <li>
        <strong>
          {{ "command-modal.lamp_status_detection" | translate }}:
        </strong>
        {{ equipmentSelected.responseData.lamp_status_detection }}
      </li>
      }
      @if (equipmentSelected.responseData.message_bitmask != null) {
      <li>
        <strong> {{ "command-modal.message-bitmask" | translate }}: </strong>
        {{ equipmentSelected.responseData.message_bitmask }}
      </li>
      }
      @if (equipmentSelected.responseData.dissociation_interval != null) {
      <li>
        <strong>
          {{ "command-modal.dissociation-interval" | translate }}:
        </strong>
        {{ equipmentSelected.responseData.dissociation_interval }}
      </li>
      }
      @if (equipmentSelected.responseData.ts_app != null) {
      <li>
        <strong> {{ "command-modal.ts-app" | translate }}: </strong>
        {{ equipmentSelected.responseData.ts_app }}
      </li>
      }
      @if (equipmentSelected.responseData.ts_jiga != null) {
      <li>
        <strong> {{ "command-modal.ts-jiga" | translate }}: </strong>
        {{ equipmentSelected.responseData.ts_jiga }}
      </li>
      }
      @if (equipmentSelected.responseData.dimming != null) {
      <li>
        <strong> {{ "command-modal.dimming" | translate }}: </strong>
        {{ equipmentSelected.responseData.dimming }} %
      </li>
      }
      @if (equipmentSelected.responseData.current_consumption != null) {
      <li>
        <strong>
          {{ "command-modal.current-consumption" | translate }}:
        </strong>
        {{ equipmentSelected.responseData.current_consumption }} mA
      </li>
      }
      @if (equipmentSelected.responseData.has_current_consumption != null) {
      <li>
        <strong>
          {{ "command-modal.has-current-consumption" | translate }}:
        </strong>
        {{ equipmentSelected.responseData.has_current_consumption }}
      </li>
      }
      @if (equipmentSelected.responseData.light_sensor_value != null) {
      <li>
        <strong> {{ "command-modal.light-sensor-value" | translate }}: </strong>
        {{ equipmentSelected.responseData.light_sensor_value }} Lux
      </li>
      }
      @if (equipmentSelected.responseData.operating_voltage != null) {
      <li>
        <strong> {{ "command-modal.operating-voltage" | translate }}: </strong>
        {{ equipmentSelected.responseData.operating_voltage }}
      </li>
      }
      @if (equipmentSelected.responseData.meter_current_consumption != null) {
      <li>
        <strong>
          {{ "command-modal.meter-current-consumption" | translate }}:
        </strong>
        {{ equipmentSelected.responseData.meter_current_consumption }}
      </li>
      }
      @if (equipmentSelected.responseData.active_power != null) {
      <li>
        <strong> {{ "command-modal.active_power" | translate }}: </strong>
        {{ equipmentSelected.responseData.active_power }}
      </li>
      }
      @if (equipmentSelected.responseData.reactive_power != null) {
      <li>
        <strong> {{ "command-modal.reactive_power" | translate }}: </strong>
        {{ equipmentSelected.responseData.reactive_power }}
      </li>
      }
      @if (equipmentSelected.responseData.active_energy != null) {
      <li>
        <strong> {{ "command-modal.active_energy" | translate }}: </strong>
        {{ equipmentSelected.responseData.active_energy }}
      </li>
      }
      @if (equipmentSelected.responseData.power_factor != null) {
      <li>
        <strong> {{ "command-modal.power_factor" | translate }}: </strong>
        {{ equipmentSelected.responseData.power_factor }}
      </li>
      }
      @if (equipmentSelected.responseData.ts_reference != null) {
      <li>
        <strong> {{ "command-modal.ts_reference" | translate }}: </strong>
        {{ equipmentSelected.responseData.ts_reference }}
      </li>
      }
      @if (equipmentSelected.responseData.lamp_control_mode == 0) {
      <li>
        <strong> {{ "command-modal.value" | translate }}:</strong>
        {{ "commands.manual-operation-mode" | translate }}
      </li>
      }
      @if (equipmentSelected.responseData.lamp_control_mode == 1) {
      <li>
        <strong> {{ "command-modal.value" | translate }}:</strong>
        {{ "commands.automatic-operation-mode" | translate }}
      </li>
      }
      @if (equipmentSelected.responseData.lamp_control_mode == 2) {
      <li>
        <strong> {{ "command-modal.value" | translate }}:</strong>
        {{ "commands.scheduled-operation-mode" | translate }}
      </li>
      }
      @if (equipmentSelected.responseData.lamp_control_mode == 3) {
      <li>
        <strong> {{ "command-modal.value" | translate }}:</strong>
        {{ "commands.mixed-operation-mode" | translate }}
      </li>
      }
      <br />
      <h1>{{ "command-modal.data-sent-title" | translate }}</h1>
      <hr />
      <!-- Título dados enviados -->
      @if (equipmentSelected.commands.requestDt) {
      <h2>
        <strong> {{ "command-modal.request-date" | translate }}: </strong>
        {{ equipmentSelected.commands.requestDt }}
      </h2>
      }
      @if (equipmentSelected.commands.type) {
      <h2>
        <strong> {{ "command-modal.query-type" | translate }}: </strong>
        {{ equipmentSelected.commands.type }}
      </h2>
      }
      @if (equipmentSelected.commands.parameter) {
      <h2>
        <strong> {{ "command-modal.parameter" | translate }}: </strong>
        {{ equipmentSelected.commands.parameter }}
      </h2>
      }
      @if (
      equipmentSelected.commands.value != null &&
      equipmentSelected.commands.parameter != 'OPM'
      ) {
      <h2>
        <strong> {{ "command-modal.value" | translate }}:</strong>
        {{ equipmentSelected.commands.value }}%
      </h2>
      }
      @if (
      equipmentSelected.commands.value == '0' &&
      equipmentSelected.commands.parameter == 'OPM'
      ) {
      <h2>
        <strong> {{ "command-modal.value" | translate }}:</strong>
        {{ "commands.manual-operation-mode" | translate }}
      </h2>
      }
      @if (
      equipmentSelected.commands.value == '1' &&
      equipmentSelected.commands.parameter == 'OPM'
      ) {
      <h2>
        <strong> {{ "command-modal.value" | translate }}:</strong>
        {{ "commands.automatic-operation-mode" | translate }}
      </h2>
      }
      @if (
      equipmentSelected.commands.value == '2' &&
      equipmentSelected.commands.parameter == 'OPM'
      ) {
      <h2>
        <strong> {{ "command-modal.value" | translate }}:</strong>
        {{ "commands.scheduled-operation-mode" | translate }}
      </h2>
      }
      @if (
      equipmentSelected.commands.value == '3' &&
      equipmentSelected.commands.parameter == 'OPM'
      ) {
      <h2>
        <strong> {{ "command-modal.value" | translate }}:</strong>
        {{ "commands.mixed-operation-mode" | translate }}
      </h2>
      }
      @if (equipmentSelected.commands.user.firstName) {
      <h2>
        <strong> {{ "command-modal.user" | translate }}: </strong>
        {{ equipmentSelected.commands.user.firstName }}
        {{ equipmentSelected.commands.user.lastName }}
      </h2>
      }
    </div>
    }
  </div>
  }

  <div mat-dialog-actions class="actions">
    @if (propertiesCommand) {
    <button mat-button [mat-dialog-close]="data" cdkFocusInitial class="btn btn-success">
      {{ "command-modal.close" | translate }}
    </button>
    }
  </div>
</div>